/**
 * @generated SignedSource<<33382a8ee537d751dc4d5ad2c069f44e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetails_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetailsAbout_item" | "PdpRespSidebarDetailsCustomization_item" | "PdpRespSidebarDetailsPricingGuidance_item" | "PdpSharedEstimateSimilarSoldPricing_item" | "getPdpEstimateSimilarSold_item">;
  readonly " $fragmentType": "PdpRespSidebarDetails_item";
};
export type PdpRespSidebarDetails_item$key = {
  readonly " $data"?: PdpRespSidebarDetails_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetails_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "isEstimateSimilarSoldVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetails_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsAbout_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsCustomization_item"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarDetailsPricingGuidance_item"
        }
      ]
    },
    {
      "condition": "isEstimateSimilarSoldVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedEstimateSimilarSoldPricing_item"
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "getPdpEstimateSimilarSold_item",
              "selections": [
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "showPricingGuidance_item",
                  "selections": [
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "pricingGuidanceHelpers_item",
                      "selections": [
                        {
                          "alias": "recommendedPrice",
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "buyerId",
                              "variableName": "userId"
                            },
                            {
                              "kind": "Variable",
                              "name": "isTrade",
                              "variableName": "isTrade"
                            },
                            {
                              "kind": "Variable",
                              "name": "priceBookName",
                              "variableName": "priceBookName"
                            },
                            {
                              "kind": "Variable",
                              "name": "userCountryCode",
                              "variableName": "userCountryCode"
                            }
                          ],
                          "concreteType": "PricingGuidance",
                          "kind": "LinkedField",
                          "name": "pricingGuidance",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FinancialAmount",
                              "kind": "LinkedField",
                              "name": "price",
                              "plural": false,
                              "selections": (v0/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FinancialAmount",
                              "kind": "LinkedField",
                              "name": "medianAmount",
                              "plural": false,
                              "selections": (v0/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FinancialAmount",
                              "kind": "LinkedField",
                              "name": "minAmount",
                              "plural": false,
                              "selections": (v0/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FinancialAmount",
                              "kind": "LinkedField",
                              "name": "maxAmount",
                              "plural": false,
                              "selections": (v0/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": [
                        {
                          "kind": "RootArgument",
                          "name": "isTrade"
                        },
                        {
                          "kind": "RootArgument",
                          "name": "priceBookName"
                        },
                        {
                          "kind": "RootArgument",
                          "name": "userCountryCode"
                        },
                        {
                          "kind": "RootArgument",
                          "name": "userId"
                        }
                      ]
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ]
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "35dbfbeffa7171884548497251e2fa13";

export default node;
